import React from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'
import { ControlledTextInput } from 'transfix-form/components'
import { ModalBase, IModalBaseProps, MODAL_TYPES } from 'transfix-ui/components/Modals'
import { Box } from 'transfix-ui/core'
import { IParserSchema, ParserSchema } from '../ParserSchema'
import { createParserTest } from '../api'
import { ParserTestRequest, ParserVersion } from '../types'

interface ISaveParserTestModalProps extends Omit<IModalBaseProps, 'modalType'> {
  onClose: () => void
  onSuccess: () => void
  selectedParserVersion?: ParserVersion
  ediInput: string
  expectedOutput: string
  isLive: boolean
}

export const SaveParserTestModal = ({
  ediInput,
  expectedOutput,
  isLive,
  onClose,
  onSuccess,
  selectedParserVersion,
  ...props
}: ISaveParserTestModalProps) => {
  const methods = useForm({
    resolver: yupResolver(ParserSchema),
  })

  const { control, handleSubmit } = methods

  const saveParserTest = async (formParams: IParserSchema) => {
    const body: ParserTestRequest = {
      configurable_parser_test: {
        edi_mapper_configurable_parser_id: selectedParserVersion?.parent_parser?.id || 0,
        name: formParams.name,
        edi_input: ediInput,
        expected_output: expectedOutput,
        is_live: isLive,
        notes: '',
      },
    }
    await createParserTest(body)
    onSuccess()
  }

  const saveHandler = handleSubmit(saveParserTest)

  const actions: IModalBaseProps['actions'] = [
    {
      label: 'Save',
      action: saveHandler,
      type: 'confirm',
      dataTest: 'confirm-button',
    },
    {
      label: 'Cancel',
      type: 'dismiss',
      dataTest: 'cancel-button',
    },
  ]

  return (
    <ModalBase
      onClose={onClose}
      dataTest='SaveParserModal'
      modalType={MODAL_TYPES.form}
      size={2}
      title='Save Parser Test '
      open
      closeOnBackdropClick
      actions={actions}
      {...props}>
      <Box mb={2}>
        <ControlledTextInput
          control={control}
          name='name'
          TextInputProps={{
            label: 'Parser Test Name',
            placeholder: 'Test Name',
          }}
        />
      </Box>
    </ModalBase>
  )
}
